import React, { ReactNode } from "react";
import { FieldValues, FormProvider, SubmitHandler, useForm } from "react-hook-form";

interface Props {
    children?: ReactNode,
    name: string,
    onSubmit: SubmitHandler<FieldValues>,
    defaultValues?: any
}

const FormContextProvider : React.FC<Props> = ({name, onSubmit, defaultValues, children}) => {
    const formParams = useForm({
        defaultValues: defaultValues
    });

    return <FormProvider {...formParams} >
        <form name={name} onSubmit={formParams.handleSubmit(onSubmit)}>
            {children}
        </form>
    </FormProvider>
}

export default FormContextProvider;